<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardVideo
            :cardContent="content"
            :pathVideoIpad="videoSplit"
            :checkWidth="CheckWidth"
            @nextRoute="nextRoute"
            @returnData="returnData"
          />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardVideo from './components/CardVideo.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardVideo, LoadingMDL},
  name: 'CTV01',
  data() {
    return {
      content: {},
      lang: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      videoSplit: '',
      CheckWidth: window.innerWidth,
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      nextRoutePath: [],
      conditionRoute: 'next',
      navigate: {},
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      // getUserTemplate: 'template/getUserTemplate',
      // loadingGetter: 'template/loadingGetter',
      getCheckAnswerResult: 'template/getCheckAnswerResult',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: {
      handler(val) {
        if (!val) return;

        this.v3Data = val;

        this.content = val.templates[0];
        this.navigate = val.templates[0].navigate;

        if (this.conditionRoute != 'next') {
          window.location.reload();
        }

        if (!this.content.enable) {
          const pathFormat = this.content.navigate.close.action.split('-');
          alert('Access denied!');
          this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
        }
        this.videoSplit = val.templates[0].content.item[0].image;

        // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

        this.loading = false;
      },
      // immediate: true,
    },
    storeLanguage: function (val) {
      this.lang = val;
    },

    '$route.params.id'() {
      this.onLoad();
    },
  },

  mounted() {
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = `CTV01-` + this.$route.params.id;
    // this.$store.dispatch('template/fetchContent', body);
    this.onLoad();
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();
      this.conditionRoute = 'next';

      const contentId = `CTV01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },

    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },

    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(val) {
      this.conditionRoute = 'go';
      let str = val.split('-');
      this.nextRoutePath = str;
      this.funcRoute();
    },
    returnData(val) {
      this.conditionRoute = 'returnData';
      let str = val.split('-');
      this.nextRoutePath = str;
      this.funcRoute();
    },
    funcRoute() {
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch update
      this.$store.dispatch('v3/saveContent', data);

      const nextAction = this.navigate.next.action;

      const path = nextAction.split('-');
      const nextPath = `/v3/${path[0]}/${path[1]}`;

      this.$router.push(nextPath);

      // this.loading = true;
      // let payload = {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // };
      // this.$store.dispatch('template/saveUserTemplateData', payload);
    },
  },
};
</script>
<style></style>
